export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const US_PHONE_NUMBER_REGEX = /^(\+1\s?)?(\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/;

export const STRICT_URL_PATTERN = /^https?:\/\/([\w-]+\.)+[\w-]{2,}(\/.*)?$/i
